<script>
import axios from 'axios'
import LoadingBar from './loading-bar'

export default {
  components: {
    LoadingBar,
  },
  data() {
    return {
      url: null,
      loading: false,
      file: null,
      message: null,
      preview: null,
      progress: null,
    }
  },
  methods: {
    upload() {
      if (!this.file || this.loading) return

      this.loading = true
      this.$refs.fileUpload.value = ''

      let message = null
      if (this.message) this.message.trim()
      message = this.message

      let data = new FormData()
      data.append('user', this.$store.state.users.user)
      data.append('file', this.file, this.file.name)
      data.append('timestamp', Date.now())
      data.append('message', message)

      axios
        .post('https://shnap.me/file.php', data, {
          headers: { 'Content-type': 'multipart/form-data' },
          onUploadProgress: event => {
            this.progress = event
          },
        })
        .finally(() => {
          this.loading = false
          this.$emit('success')
        })
    },
    handleChange(event) {
      this.file = event.target.files[0]
      if (this.file) this.preview = URL.createObjectURL(this.file)
    },
  },
}
</script>

<template>
  <div
    class="flex flex-col fixed inset-0 bg-white z-10 p-10 pb-6 justify-center select-none"
  >
    <div
      class="shadow border border-b-0 border-gray-400 w-full lg:w-2/3 flex-1 rounded-t-lg bg-gray-200 mx-auto"
    >
      <input
        id="upload"
        ref="fileUpload"
        type="file"
        accept=".jpg, .png, .jpeg"
        class="fileUploadInput"
        @change="handleChange"
      />
      <label
        for="upload"
        class="w-full h-full rounded-t-lg flex justify-center"
      >
        <div
          v-if="file"
          class="w-full h-full rounded-t-lg bg-contain bg-no-repeat bg-center"
          :style="{ 'background-image': `url(${preview})` }"
        />
        <div v-else class="w-full h-full rounded flex">
          <div class="m-auto">
            <i class="far fa-hand-pointer text-gray-600 text-5xl" />
          </div>
        </div>
      </label>
    </div>
    <div class="mx-auto w-full lg:w-2/3 mt-1 flex">
      <input
        v-model="message"
        type="text"
        class="flex-1 border border-gray-400 bg-gray-200 rounded-b-lg shadow px-2 md:px-4 py-2 md:text-lg"
        placeholder="Optional message"
      />
    </div>
    <div class="mt-4 mx-auto w-full lg:w-2/3 flex">
      <button
        class="border border-gray-500 text-gray-700 rounded px-4 py-2 text-xl cursor-default hover:bg-gray-300 active:bg-gray-400"
        @click="upload"
      >
        <i class="fas fa-cloud-upload-alt mr-2" />{{
          loading ? 'Please wait..' : 'Upload'
        }}
      </button>
    </div>
    <LoadingBar
      v-if="loading"
      class="h-1 my-auto w-full bottom-0 border absolute -mx-10"
      :progress-event="progress"
    />
  </div>
</template>
